// src/pages/Admissions.jsx
import React, { useState } from 'react';
import './Admissions.css';

const Admissions = () => {
  const [activeTab, setActiveTab] = useState('islamic');
  
  const handleApplyClick = () => {
    window.location.href = 'https://docs.google.com/forms/d/e/1FAIpQLScC0FPYtQdW4u4EMEpf2YT8ME8Ic31GH9Ooayt1BtPoe76ajA/viewform';
  };

  return (
    <div className="admissions-page">
      <div className="admissions-header">
        <h1>Admissions à l'U2S</h1>
        <p>Rejoignez notre communauté académique d'excellence</p>
      </div>
      
      <div className="admissions-tabs">
        <button 
          className={`tab-btn ${activeTab === 'islamic' ? 'active' : ''}`}
          onClick={() => setActiveTab('islamic')}
        >
          Licence en Études Islamiques
        </button>
        <button 
          className={`tab-btn ${activeTab === 'education' ? 'active' : ''}`}
          onClick={() => setActiveTab('education')}
        >
          Licence en Sciences de l'Éducation
        </button>
      </div>
      
      <div className="admissions-content">
        {activeTab === 'islamic' ? (
          <div className="program-details">
            <h2>Licence en Études Islamiques</h2>
            <div className="program-overview">
              <div className="overview-card">
                <h3>Durée</h3>
                <p>3 ans (6 semestres)</p>
              </div>
              <div className="overview-card">
                <h3>Langue d'enseignement</h3>
                <p>Arabe et Français</p>
              </div>
            </div>
            
            <div className="program-description">
              <h3>Description du Programme</h3>
              <p>Ce programme offre une formation complète en Études islamiques. Les étudiants acquièrent une compréhension approfondie du Coran, de la Sunna, de la jurisprudence islamique, de l'histoire islamique et de la pensée musulmane moderne.</p>
              
              <h3>Objectifs Pédagogiques</h3>
              <ul>
                <li>Maîtriser les sources fondamentales de l'Islam</li>
                <li>Développer une compréhension critique des textes religieux</li>
                <li>Acquérir des compétences en recherche islamique</li>
                <li>Comprendre les défis contemporains de la pensée islamique</li>
              </ul>
              
              <h3>Débouchés Professionnels</h3>
              <ul>
                <li>Enseignement religieux</li>
                <li>Recherche académique</li>
                <li>Conseil en éthique islamique</li>
                <li>Médiation culturelle</li>
                <li>Travail dans les organisations islamiques</li>
              </ul>
            </div>
          </div>
        ) : (
          <div className="program-details">
            <h2>Licence en Sciences de l'Éducation</h2>
            <div className="program-overview">
              <div className="overview-card">
                <h3>Durée</h3>
                <p>3 ans (6 semestres)</p>
              </div>
              <div className="overview-card">
                <h3>Langue d'enseignement</h3>
                <p>Français</p>
              </div>
              <div className="overview-card">
                <h3>Diplôme</h3>
                <p>Licence Accréditée par l'État</p>
              </div>
            </div>
            
            <div className="program-description">
              <h3>Description du Programme</h3>
              <p>Ce programme forme des professionnels de l'éducation capables d'intervenir dans divers contextes éducatifs. Il combine théorie et pratique pour préparer les étudiants aux défis des systèmes éducatifs modernes, avec une attention particulière au contexte africain.</p>
              
              <h3>Objectifs Pédagogiques</h3>
              <ul>
                <li>Comprendre les fondements psychologiques de l'apprentissage</li>
                <li>Maîtriser les méthodologies pédagogiques</li>
                <li>Développer des compétences en conception de programmes éducatifs</li>
                <li>Analyser les politiques éducatives</li>
              </ul>
              
              <h3>Débouchés Professionnels</h3>
              <ul>
                <li>Enseignement primaire et secondaire</li>
                <li>Conception pédagogique</li>
                <li>Administration scolaire</li>
                <li>Formation professionnelle</li>
                <li>Consultance éducative</li>
              </ul>
            </div>
          </div>
        )}
      </div>
      
      <div className="application-process">
        <h2>Processus d'Admission</h2>
        <div className="process-steps">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Pré-inscription en Ligne</h3>
            <p>Remplissez le formulaire de candidature et téléchargez les documents requis</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>Examen du Dossier</h3>
            <p>Votre dossier de candidature sera examiné par un comité pédagogique</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Entretien</h3>
            <p>Entretien avec le comité pédagogique</p>
          </div>
          <div className="step">
            <div className="step-number">4</div>
            <h3>Décision d'Admission</h3>
            <p>Notification de la décision dans les 15 jours</p>
          </div>
        </div>
      </div>
      
      <div className="documents-section">
        <h2>Documents Requis</h2>
        <ul>
          <li>Formulaire de candidature dûment rempli</li>
          <li>Copie certifiée du Baccalauréat ou diplôme équivalent</li>
          <li>Copie légalisée de la carte d'identité nationale ou passeport</li>
          <li>Deux photos d'identité récentes</li>
        </ul>
      </div>
      
      <div className="apply-section">
        <h2>Prêt à Postuler?</h2>
        <p>Rejoignez notre communauté d'apprenants et de chercheurs passionnés</p>
        <button className="apply-btn" onClick={handleApplyClick}>Commencer ma candidature</button>
      </div>
    </div>
  );
};

export default Admissions;